<template>
  <div>
    <!-- 添加答案弹框 -->
    <el-dialog
        title="添加答案"
        :visible.sync="visible"
        width="800px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
    <!-- 多语言选项卡 -->
    <el-tabs
      v-if="languageList.length > 0"
      type="card"
      v-model="currentLanguageCode"
      @tab-click="handleLanguageTabClick"
      style="margin-bottom: 20px;"
    >
      <el-tab-pane
        v-for="(item, index) in languageList"
        :key="index"
        :label="item.name"
        :name="item.code"
      ></el-tab-pane>
    </el-tabs>
      <div style="margin-bottom: 10px">
        <span>题目：{{formData.name}}</span>
        <div v-if="formData.icon">
          <img :src="formData.icon" style="width: 100px;height: 100px;object-fit: contain">
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <span>答题方式：</span>
        <span>{{ formData.answerWay==='sel1' ? '单选' : formData.answerWay==='sel2' ? '多选' : '填空题' }}</span>
      </div>
      <div style="margin-bottom: 10px">
        <span>布局方式：</span>
        <span>{{ formData.view==='ve1' ? '列表形' : formData.view==='ve2' ? '田字形' : '' }}</span>
      </div>
      <div class="public-table-data">
        <el-table
            ref="multipleTable"
            size="mini"
            :data="answerTableData"
            border
            style="width: 100%"
            row-key="menuId"
            v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column prop="icon" label="图标" width="100" align="center">
            <template slot-scope="scope">
              <UploadImage simple v-model="scope.row.icon" :disabled="loading" size="40px" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="答案" width="200" align="center">
            <template slot-scope="scope">
              <el-input
                  type="text"
                  v-model="scope.row.name"
                  size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="isRight" label="是否正确" width="80" align="center">
            <template slot-scope="scope">
              <InlineTableControler
                @change="handleIsRightChange(scope.row,scope.$index)"
                :options="CORRECT_OPTIONS"
                v-model="scope.row.isRight"
              />
            </template>
          </el-table-column>
          <el-table-column prop="sortOrder" label="排序" width="100" align="center">
            <template slot-scope="scope">
              <InlineTableControler
                  v-model="scope.row.sortOrder"
                  type="number"
                />
            </template>
          </el-table-column>
          <el-table-column prop="isRight" label="是否下架" width="80" align="center">
            <template slot-scope="scope">
              <InlineTableControler
                :options="CORRECT_OPTIONS"
                v-model="scope.row.isOffline"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleAnswerDelete(scope.row, scope.$index)"
                  type="danger"
                  plain
              >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="onClose"
        >取 消</el-button
        >
        <el-button size="medium" type="success" @click="handleAddAnswer"
        >添加答案</el-button
        >
        <el-button size="medium" type="primary" @click="submitAnswer"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';
import { CORRECT_OPTIONS } from "@/config";

export default {
  name: "AnswerPanel",
  components: {
    UploadImage,
    InlineTableControler
  },
  data() {
    return {
      CORRECT_OPTIONS,
      loading: false,
      visible: false,
      formData: {},
      answerTableData: [],
      languageList: [],
      currentLanguageCode: '',
    }
  },
  created() {
    this.getLanguageList();
  },
  methods: {
    handleIsRightChange(row,index) {
      if(this.formData.answerWay === 'sel1'){
        this.answerTableData.forEach((item,i) => {
          if(i !== index){
            item.isRight = 0;
          }
        });
      }
    },
    async getLanguageList() {
      try {
        const { data: res } = await this.$post('/language/list', { adminStatus: 1 });
        if (res && res.data) {
          this.languageList = res.data;
          this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'EN';
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    },
    handleLanguageTabClick(tab) {
      this.currentLanguageCode = tab.name;
      this.getAnswerList(this.formData.id);
    },
    async getAnswerList(questionId) {
      if(!questionId) return;
      this.loading = true;
      try {
        const { data: res } = await this.$post(
          `/question/answer/list`,
          { pageNo: 1, pageSize: 1000, questionId },
          { headers: { isLoading: true, "Language-Code": this.currentLanguageCode } }
        );
        if (res && res.data) {
          this.answerTableData = res.data;
        }
      } catch (error) {
        console.error('获取答案列表失败:', error);
        this.$message.error('获取答案列表失败');
      } finally {
        this.loading = false;
      }
    },
    handleAddAnswer() {
      this.answerTableData.push({
        icon: "",
        name: "",
        isRight: 0,
        sortOrder: "",
        isOffline:0,
      });
    },
    submitAnswer() {
      const {id:questionId} = this.formData;
      this.$confirm("确认保存数据, 是否继续?", "提示", { type: "info" }).then(async () => {
        let isRightCount = 0;
        this.answerTableData.forEach(item => {
          if(item.isRight === 1){
            isRightCount++;
          }
        });
        if(isRightCount === 0){
          this.$message.error("请至少选择一个正确答案");
          return;
        }
        // 保证每个答案对象都带有 questionId
        const data = this.answerTableData.map(item => ({
          ...item,
          questionId
        }));
        const { data: resData } = await this.$post(
          "/question/answer/saveBatch",
          data,
          { headers: { "Language-Code": this.currentLanguageCode, isLoading: true } }
        );
        if (resData.result != 200) return;
        this.$message.success("添加成功!");
        this.getAnswerList(this.formData.id);
        // this.onClose();
      });
    },
    handleAnswerDelete(row, index) {
      if (!row.questionId) {
        this.answerTableData.splice(index, 1);
      } else {
        this.$confirm("此操作将删除答案数据, 是否继续?", "提示", { type: "warning" }).then(async () => {
          const { data: resData } = await this.$get(
            `/question/answer/delete/${row.id}`,
            // { headers: { "Language-Code": this.currentLanguageCode, isLoading: true } }
          );
          if (resData.result != 200){
            this.$message.error(resData.message);
            return;
          } 
          this.getAnswerList(this.formData.id);
          this.$message.success("删除成功!");
        });
      }
    },
    open(data = {}) {
      this.visible = true;
      this.formData = {};
      this.answerTableData = []
      this.formData = { ...data };
      if (this.languageList.length === 0) {
        this.getLanguageList();
      }
      this.getAnswerList(data.id);
    },
    onClose() {
      this.visible = false;
      this.formData = {};
      this.answerTableData = [];
    }
  },
  watch: {
    currentLanguageCode(newVal) {
      (this.formData.id) &&  this.getAnswerList(this.formData.id);
    }
  }, 
}
</script>

<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.active_display {
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.public-table-data {
  margin-bottom: 20px;
}
.public-dialog{
  :deep(.el-dialog){
    margin:0 auto !important;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .el-dialog__header,.el-dialog__footer{
      flex:none;
      width: 100%;
      box-sizing: border-box;
    }
    .el-dialog__body{
      flex: 1 1 auto;
      overflow-y: auto;
      box-sizing: border-box;
    }
  }
  &.fullscreen{
    :deep(.el-dialog){
      height: 100vh;
      width: 100vw;
    }
  }
}
</style>
